import { Injectable, inject } from '@angular/core';
import { ADMIN_AUTH_CONFIG, AuthConfig } from './auth.config';
import { Auth } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AdminAuth extends Auth {
  protected override authConfig = inject<AuthConfig>(ADMIN_AUTH_CONFIG);
}
